import RuleOutlinedIcon from '@mui/icons-material/RuleOutlined';

import AddressBookIcon from '../assets/images/icon-flow-address-book.svg';
import AssetsFlowIcon from '../assets/images/icon-flow-assets-manager.svg';
import AutomatedCampaignsFlowIcon from '../assets/images/icon-flow-automated-campaigns.svg';
import BulkSendIcon from '../assets/images/icon-flow-bulk-send.svg';
import BusinessReasonsIcon from '../assets/images/icon-flow-business-reasons.svg';
import CampaignsFlowIcon from '../assets/images/icon-flow-campaigns.svg';
import ClaimLinkTemplatesFlowIcon from '../assets/images/icon-flow-claim-link-templates.svg';
import CustomMessagesFlowIcon from '../assets/images/icon-flow-custom-messages.svg';
import ReportsIcon from '../assets/images/icon-flow-delivery-reports.svg';
import EmailTemplatesFlowIcon from '../assets/images/icon-flow-email-templates.svg';
import ExperienceManagerFlowIcon from '../assets/images/icon-flow-experience-manager.svg';
import IntegrationFlowIcon from '../assets/images/icon-flow-integrations.svg';
import InventoryFlowIcon from '../assets/images/icon-flow-inventory.svg';
import OneLinkManagerFlowIcon from '../assets/images/icon-flow-one-link-manager.svg';
import OrganizationsFlowIcon from '../assets/images/icon-flow-organizations.svg';
import SingleSendIcon from '../assets/images/icon-flow-send.svg';
import UsersFlowIcon from '../assets/images/icon-flow-users.svg';

import { ReactComponent as AssetsManagerIconActive } from '../assets/images/icon-assets-manager-active.svg';
import { ReactComponent as AssetsManagerIcon } from '../assets/images/icon-assets-manager.svg';
import { ReactComponent as AutomatedCampaignsIconActive } from '../assets/images/icon-automated-campaigns-active.svg';
import { ReactComponent as AutomatedCampaignsIcon } from '../assets/images/icon-automated-campaigns.svg';
import { ReactComponent as AddressBookSidebarIconActive } from '../assets/images/icon-book-active.svg';
import { ReactComponent as AddressBookSidebarIcon } from '../assets/images/icon-book.svg';
import { ReactComponent as BusinessReasonsSidebarIconActive } from '../assets/images/icon-business-reasons-active.svg';
import { ReactComponent as CampaignsIconActive } from '../assets/images/icon-campaigns-active.svg';
import { ReactComponent as CampaignsIcon } from '../assets/images/icon-campaigns.svg';
import { ReactComponent as CustomNotesTemplatesIcon } from '../assets/images/icon-custom-notes-templates.svg';
import { ReactComponent as DeliveryIconActive } from '../assets/images/icon-delivery-reports-active.svg';
import { ReactComponent as DeliveryIcon } from '../assets/images/icon-delivery-reports.svg';
import { ReactComponent as EmailTemplatesIcon } from '../assets/images/icon-email-templates.svg';
import { ReactComponent as ExperienceManagerIconActive } from '../assets/images/icon-experience-manager-active.svg';
import { ReactComponent as ExperienceManagerIcon } from '../assets/images/icon-experience-manager.svg';
import { ReactComponent as HomeIconActive } from '../assets/images/icon-home-active.svg';
import { ReactComponent as HomeIcon } from '../assets/images/icon-home.svg';
import { ReactComponent as IntegrationIconActive } from '../assets/images/icon-integrations-active.svg';
import { ReactComponent as IntegrationIcon } from '../assets/images/icon-integrations.svg';
import { ReactComponent as InventoryIconActive } from '../assets/images/icon-inventory-active.svg';
import { ReactComponent as InventoryIcon } from '../assets/images/icon-inventory.svg';
import { ReactComponent as BusinessReasonsSidebarIcon } from '../assets/images/icon-menu-business-reasons.svg';
import { ReactComponent as OneLinkManagerIconActive } from '../assets/images/icon-one-link-manager-active.svg';
import { ReactComponent as OneLinkManagerIcon } from '../assets/images/icon-one-link-manager.svg';
import { ReactComponent as OrganizationsIconActive } from '../assets/images/icon-organizations-active.svg';
import { ReactComponent as OrganizationsIcon } from '../assets/images/icon-organizations.svg';
import { ReactComponent as CreateSendIconActive } from '../assets/images/icon-send-active.svg';
import { ReactComponent as CreateSendIcon } from '../assets/images/icon-send.svg';
import { ReactComponent as TemplatesIconActive } from '../assets/images/icon-templates-active.svg';
import { ReactComponent as TemplatesIcon } from '../assets/images/icon-templates.svg';
import { ReactComponent as UsersIconActive } from '../assets/images/icon-users-active.svg';
import { ReactComponent as UsersIcon } from '../assets/images/icon-users.svg';

import { TFlowOption } from '../types/dashboard';
import { TSidenavItem } from '../types/sidenav';
import { routes } from './routing';
import { DEPT_ADMIN, DISTRIBUTOR, ORG_ADMIN, SUPER_ADMIN } from './users';

export const mainMenuItems: TSidenavItem[] = [
  {
    icon: HomeIcon,
    iconActive: HomeIconActive,
    title: 'Home',
    route: routes.dashboard,
    usedInMobile: true,
    usedInDesktop: true,
  },
  {
    icon: CreateSendIcon,
    iconActive: CreateSendIconActive,
    title: 'Create Send',
    route: routes.createSend.root,
    usedInMobile: true,
    usedInDesktop: true,
    dataAction: 'nav_create_send',
  },
  {
    icon: AutomatedCampaignsIcon,
    iconActive: AutomatedCampaignsIconActive,
    title: 'Automated Campaigns',
    route: routes.automations,
    usedInMobile: true,
    usedInDesktop: true,
    roles: [DISTRIBUTOR, ORG_ADMIN, SUPER_ADMIN],
    dataAction: 'nav_automations',
  },
  {
    icon: DeliveryIcon,
    iconActive: DeliveryIconActive,
    title: 'Delivery Reports',
    route: routes.reports.root,
    usedInMobile: true,
    usedInDesktop: true,
    dataAction: 'nav_delivery_reports',
  },
  {
    icon: IntegrationIcon,
    iconActive: IntegrationIconActive,
    title: 'Integrations',
    route: routes.integrations,
    usedInMobile: true,
    usedInDesktop: true,
    dataAction: 'nav_integrations',
  },
  {
    icon: UsersIcon,
    iconActive: UsersIconActive,
    title: 'Users',
    route: routes.users.root,
    usedInMobile: true,
    usedInDesktop: true,
    roles: [DEPT_ADMIN, ORG_ADMIN, DISTRIBUTOR, SUPER_ADMIN],
    dataAction: 'nav_users',
  },
  {
    icon: OneLinkManagerIcon,
    iconActive: OneLinkManagerIconActive,
    title: 'One Link Manager',
    route: routes.oneLinkManager.root,
    usedInMobile: true,
    usedInDesktop: true,
    roles: [DEPT_ADMIN, ORG_ADMIN, DISTRIBUTOR, SUPER_ADMIN],
    dataAction: 'nav_one_link_manager',
  },
  {
    icon: RuleOutlinedIcon,
    title: 'Bulk Send Manager',
    route: routes.bulkSendManager.root,
    usedInMobile: true,
    usedInDesktop: true,
    roles: [DEPT_ADMIN, ORG_ADMIN, DISTRIBUTOR, SUPER_ADMIN],
    dataAction: 'nav_bulk_send_manager',
  },
  {
    icon: ExperienceManagerIcon,
    iconActive: ExperienceManagerIconActive,
    title: 'Experience Manager',
    usedInMobile: true,
    usedInDesktop: true,
    dataAction: 'nav_experience_manager',
    subItems: [
      {
        icon: TemplatesIcon,
        iconActive: TemplatesIconActive,
        title: 'Claim Link Templates',
        route: routes.experienceManager.claimLink,
        usedInMobile: true,
        usedInDesktop: true,
        isSubItem: true,
        dataAction: 'nav_claim_link_experiences',
      },
      {
        icon: EmailTemplatesIcon,
        title: 'Email Templates',
        route: routes.experienceManager.emailTemplates,
        usedInMobile: true,
        usedInDesktop: true,
        isSubItem: true,
        dataAction: 'nav_email_templates',
      },
      {
        icon: CustomNotesTemplatesIcon,
        title: 'Custom Messages',
        route: routes.experienceManager.customMessages,
        usedInMobile: true,
        usedInDesktop: true,
        isSubItem: true,
        dataAction: 'nav_custom_messages',
      },
    ],
  },
  {
    icon: AssetsManagerIcon,
    iconActive: AssetsManagerIconActive,
    title: 'Assets Manager',
    usedInMobile: true,
    usedInDesktop: true,
    dataAction: 'nav_assets_manager',
    subItems: [
      {
        icon: CampaignsIcon,
        iconActive: CampaignsIconActive,
        title: 'Campaigns',
        route: '/campaigns',
        usedInMobile: true,
        usedInDesktop: true,
        isSubItem: true,
        dataAction: 'nav_campaigns',
      },
      {
        icon: InventoryIcon,
        iconActive: InventoryIconActive,
        title: 'Inventory',
        route: routes.inventory.root,
        usedInMobile: true,
        usedInDesktop: true,
        isSubItem: true,
        dataAction: 'nav_inventory',
      },
      {
        icon: OrganizationsIcon,
        iconActive: OrganizationsIconActive,
        title: 'Organizations',
        route: routes.organizations.root,
        usedInMobile: true,
        usedInDesktop: true,
        isSubItem: true,
        roles: [DISTRIBUTOR, SUPER_ADMIN],
        dataAction: 'nav_organizations',
      },
      {
        icon: BusinessReasonsSidebarIcon,
        iconActive: BusinessReasonsSidebarIconActive,
        title: 'Business Reasons',
        route: routes.businessReasons,
        usedInMobile: true,
        usedInDesktop: true,
        isSubItem: true,
        dataAction: 'nav_business_reasons',
      },
      {
        icon: AddressBookSidebarIcon,
        iconActive: AddressBookSidebarIconActive,
        title: 'Address Book',
        route: routes.addressBook,
        usedInMobile: true,
        usedInDesktop: true,
        isSubItem: true,
        dataAction: 'nav_address_book',
      },
    ],
  },
];

export const additionMenuItems: TSidenavItem[] = [
  // { icon: InformationIcon, title: 'Helpdesk', route: routes.userInfo, usedInMobile: true, usedInDesktop: false, },
  // { icon: SettingsIcon, title: 'Settings', route: routes.settings, usedInMobile: true, usedInDesktop: false, },
];

export const dashboardItems: TFlowOption[] = [
  {
    key: 'create-send',
    title: 'Create Send',
    description: 'Create a Send to one or more recipients',
    link: routes.createSend.root,
    icon: SingleSendIcon,
    dataAction: 'create_send',
  },
  {
    key: 'automated-campaigns',
    title: 'Automated Campaigns',
    description: 'Add integrations to automatically trigger Sends',
    link: routes.automations,
    icon: AutomatedCampaignsFlowIcon,
    roles: [DISTRIBUTOR, ORG_ADMIN, SUPER_ADMIN],
    dataAction: 'automations',
  },
  {
    key: 'delivery-reports',
    title: 'Delivery Reports',
    description: 'See past Sends and their status',
    link: routes.reports.root,
    icon: ReportsIcon,
    dataAction: 'delivery_reports',
  },
  {
    key: 'integration-options',
    title: 'Integrated Options',
    description: 'Status of your product integrations',
    link: routes.integrations,
    icon: IntegrationFlowIcon,
    dataAction: 'integrations',
  },
  {
    key: 'users-list',
    title: 'Users',
    description: 'Manage all users in one page',
    link: routes.users.root,
    icon: UsersFlowIcon,
    roles: [DEPT_ADMIN, ORG_ADMIN, DISTRIBUTOR, SUPER_ADMIN],
    dataAction: 'users',
  },
  {
    key: 'one-link-manager',
    title: 'One Link Manager',
    icon: OneLinkManagerFlowIcon,
    description: 'Manage Sends created with One Link',
    link: routes.oneLinkManager.root,
    roles: [DEPT_ADMIN, ORG_ADMIN, DISTRIBUTOR, SUPER_ADMIN],
    dataAction: 'one_link_manager',
  },
  {
    key: 'bulk-send-manager',
    title: 'Bulk Send Manager',
    icon: BulkSendIcon,
    description: 'Track bulk sends and download their results',
    link: routes.bulkSendManager.root,
    roles: [DEPT_ADMIN, ORG_ADMIN, DISTRIBUTOR, SUPER_ADMIN],
    dataAction: 'bulk_send_manager',
  },
  {
    key: 'experience-manager',
    title: 'Experience Manager',
    description: 'Customize claim pages, emails, and messages',
    icon: ExperienceManagerFlowIcon,
    dataAction: 'experience_manager',
    subFlowOptions: [
      {
        key: 'claim-link-templates',
        title: 'Claim Page Templates',
        description: 'Customize the claim page recipients see',
        link: routes.experienceManager.claimLink,
        icon: ClaimLinkTemplatesFlowIcon,
        dataAction: 'claim_link_templates',
      },
      {
        key: 'email-templates',
        title: 'Email Templates',
        description: 'Customize the emails recipients receive',
        link: routes.experienceManager.emailTemplates,
        icon: EmailTemplatesFlowIcon,
        dataAction: 'email_templates',
      },
      {
        key: 'custom-messages',
        title: 'Custom Messages',
        description: 'Personal notes included with your sends',
        link: routes.experienceManager.customMessages,
        icon: CustomMessagesFlowIcon,
        dataAction: 'custom_messages',
      },
    ],
  },
  {
    key: 'assets-manager',
    title: 'Assets Manager',
    description: 'Manage Campaigns, Inventory, and Templates',
    icon: AssetsFlowIcon,
    dataAction: 'assets_manager',
    subFlowOptions: [
      {
        key: 'campaigns',
        title: 'Campaigns',
        description: 'Create and manage campaign settings for your sends',
        link: routes.campaigns.root,
        icon: CampaignsFlowIcon,
        dataAction: 'campaigns',
      },
      {
        key: 'inventory',
        title: 'Inventory',
        description: 'Review stock, see low-stock alerts, and export reports',
        link: routes.inventory.root,
        icon: InventoryFlowIcon,
        dataAction: 'inventory',
      },
      {
        key: 'organizations',
        title: 'Organizations',
        description: 'Manage company details, locations, and departments',
        link: routes.organizations.root,
        icon: OrganizationsFlowIcon,
        roles: [DISTRIBUTOR, SUPER_ADMIN],
        dataAction: 'organizations',
      },
      {
        key: 'business-reasons',
        title: 'Business Reasons',
        description: 'Tag sends for clearer tracking and reporting',
        link: routes.businessReasons,
        icon: BusinessReasonsIcon,
        dataAction: 'business_reasons',
      },
      {
        key: 'address-book',
        title: 'Address Book',
        description: 'Manage shipping addresses and campaign address options',
        link: routes.addressBook,
        icon: AddressBookIcon,
        dataAction: 'address_book',
      },
    ],
  },
];
